// How close to the bottom of an option listbox counts as "scrolled to the end" -- a little over one
// option row, so the next page starts loading just before the user reaches the last option.
const LISTBOX_SCROLL_THRESHOLD_PX = 48

/**
 * Whether an infinite-scroll listbox has been scrolled close enough to its end to request the next
 * page. Shared by every paginated Teammate picker so they all page at the same point (WF-2751).
 */
export function isListboxNearBottom(listbox: HTMLElement): boolean {
  return listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - LISTBOX_SCROLL_THRESHOLD_PX
}
